/**
 * November 2017 - This interface moved from odsp-shared-sharing
 */

const enum SharePermission {
    view = 1,
    edit = 2
}

export default SharePermission;
